import strings from '../../../Localization/Localization';

import { store } from '../../../Store/configureStore';

import { getSearchableTechnicalData } from '../../../API/CartTechnicalData';

import { fetchPartners } from '../../../API/Partners';
import { fetchPartnerAccounts } from '../../../API/PartnerAccounts';
import { fetchPlaces } from '../../../API/Places';
import { fetchFamilies } from '../../../API/ProductFamilies';
import { fetchSubFamilies } from '../../../API/ProductSubFamilies';

import { timeframe } from '../common';

let serialNumber = {
  fieldKey: "serialNumber",
  label: strings.form.service.serialNumber.label,
  type: "text",
  showOnDisabled: () => false,
  validators: [],
}

let terminationTicket = {
  fieldKey: "terminationTicket",
  label: strings.form.service.terminationTicket.label,
  type: "text",
  showOnDisabled: () => false,
  validators: [],
}

let orderNumber = {
  fieldKey: "orderNumber",
  label: strings.form.service.orderNumber.label,
  type: "text",
  showOnDisabled: () => false,
  validators: [],
}

let quoteNumber = {
  fieldKey: "quoteNumber",
  label: strings.form.service.quoteNumber.label,
  type: "text",
  showOnDisabled: () => false,
  validators: [],
}

let productName = {
  fieldKey: "productName",
  label: strings.form.service.productName.label,
  type: "text",
  showOnDisabled: () => false,
  validators: [],
}

let price = {
  fieldKey: "price",
  type: "price",
  label: strings.form.service.price.label,
  showOnDisabled: () => false,
  disabled: (getValues, getExtraValues) => {
    let credentials = getExtraValues().credentials();
    return !credentials.roles.includes('ROLE_NYUKOM');
  },
  validators: []
}

export const state = {
  fieldKey: "state",
  label: strings.form.service.state.label,
  type: "dropdownMulti",
  showOnDisabled: () => false,
  validators: [],

  input: 'options',
  finalValues: 'objects',
  options: [
    {
      value: 'active',
      label: strings.form.service.state.options.active
    },
    {
      value: 'inactive',
      label: strings.form.service.state.options.inactive
    },
    {
      value: 'termination',
      label: strings.form.service.state.options.termination
    },
    {
      value: 'termination_waiting',
      label: strings.form.service.state.options.terminationWaiting
    },
    {
      value: 'termination_scheduled',
      label: strings.form.service.state.options.terminationScheduled
    },
    {
      value: 'terminated',
      label: strings.form.service.state.options.terminated
    },
  ],
}

let partner = {
  fieldKey: "partner",
  label: strings.form.service.partner.label,
  type: "dropdownEntity",
  showOnDisabled: () => false,
  validators: [],

  showEmpty: true,
  assertObjectDefaultValue: true,
  loader: {
    id: "partner",
    loader: fetchPartners,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let client = {
  fieldKey: "client",
  label: strings.form.service.client.label,
  type: "dropdownEntity",
  disabled: (getValues) => getValues(0).partner === undefined || getValues(0).partner === null || getValues(0).partner.id === undefined,

  validators: [],

  events: [
    {
      id: "reload",
      event: "onChange",
      target: "partner",
      function: (component) => component && component.reloadData()
    }
  ],

  showEmpty: true,
  assertObjectDefaultValue: true,
  loader: {
    id: "client",
    loader: fetchPartnerAccounts,
    loaderRequire: (value, getValues) => getValues(0) && getValues(0)["partner"] && getValues(0)["partner"]["id"],
    loaderArguments: (value, getValues) => {
      return [{
        partner_id: getValues(0)["partner"]["id"]
      }]
    },
  },

  adapter: {
    requirement: (data) => data["id"] && data["partner_type"] && data["partner_type"]["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["partner_type"]["name"],
  },
}

let place = {
  fieldKey: "place",
  label: strings.form.service.place.label,
  type: "dropdownEntity",
  disabled: (getValues) => getValues(0).partner === undefined || getValues(0).partner === null || getValues(0).partner.id === undefined,
  validators: [],

  events: [
    {
      id: "reload",
      event: "onChange",
      target: "partner",
      function: (component) => component && component.reloadData()
    }
  ],

  showEmpty: true,
  assertObjectDefaultValue: true,
  loader: {
    id: "partnerPlaces",
    loader: fetchPlaces,
    loaderRequire: (value, getValues) => getValues(0) && getValues(0)["partner"] && getValues(0)["partner"]["id"],
    loaderArguments: (value, getValues) => {
      return [{
        partner_id: getValues(0)["partner"]["id"],
        active: 1
      }]
    },
  },

  adapter: {
    requirement: (data) => data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let productFamily = {
  fieldKey: "productFamily",
  label: strings.form.service.productFamily.label,
  type: "dropdownEntity",

  validators: [],

  showEmpty: true,
  assertObjectDefaultValue: true,
  loader: {
    id: "productFamilies",
    loader: fetchFamilies,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let productSubFamily = {
  fieldKey: "productSubFamily",
  label: strings.form.service.productSubFamily.label,
  type: "dropdownEntity",

  validators: [],

  events: [
    {
      id: "reload",
      event: "onChange",
      target: "productFamily",
      function: (component) => component.reloadData()
    }
  ],

  showEmpty: true,
  assertObjectDefaultValue: true,
  loader: {
    id: "productSubFamilies",
    loader: fetchSubFamilies,
    loaderRequire: (value, getValues) => getValues(0)["productFamily"] && getValues(0)["productFamily"]["id"],
    loaderArguments: (value, getValues) => {
      return [{
        product_family_id: getValues(0)["productFamily"]["id"]
      }]
    },
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let deliveryDateMin = {
  fieldKey: "deliveryDateMin",
  type: "date",
  label: strings.form.service.deliveryDateMin.label,
  showOnDisabled: () => false,
  validators: []
}

let deliveryDateMax = {
  fieldKey: "deliveryDateMax",
  type: "date",
  label: strings.form.service.deliveryDateMax.label,
  showOnDisabled: () => false,
  validators: []
}

let updateDateMin = {
  fieldKey: "updateDateMin",
  type: "date",
  label: strings.form.service.updateDateMin.label,
  showOnDisabled: () => false,
  disabled: (getValues, getExtraValues) => {
    let credentials = getExtraValues().credentials();
    return !credentials.roles.includes('ROLE_NYUKOM');
  },
  validators: []
}

let updateDateMax = {
  fieldKey: "updateDateMax",
  type: "date",
  label: strings.form.service.updateDateMax.label,
  showOnDisabled: () => false,
  disabled: (getValues, getExtraValues) => {
    let credentials = getExtraValues().credentials();
    return !credentials.roles.includes('ROLE_NYUKOM');
  },
  validators: []
}

let contractEndAtExpectedMin = {
  fieldKey: "contractEndAtExpectedMin",
  type: "date",
  label: strings.form.service.contractEndAtExpectedMin.label,
  showOnDisabled: () => false,
  validators: []
}

let contractEndAtExpectedMax = {
  fieldKey: "contractEndAtExpectedMax",
  type: "date",
  label: strings.form.service.contractEndAtExpectedMax.label,
  showOnDisabled: () => false,
  validators: []
}

let contractTacitAgreement = {
  fieldKey: "contractTacitAgreement",
  label: strings.form.service.contractTacitAgreement.label,
  type: "triswitch",
  showOnDisabled: () => false,
  validators: [],
}

let emptyApiKey = {
  fieldKey: "emptyApiKey",
  type: "switch",
  label: strings.form.service.emptyApiKey.label,
  disabled: (getValues, getExtraValues) => {
    let credentials = getExtraValues().credentials();
    return !credentials.roles.includes('ROLE_NYUKOM');
  },
  showOnDisabled: () => false,
  validators: []
}

let consumptionDate = {
  fieldKey: "consumptionDate",
  type: "date",
  label: strings.form.service.consumptionDate.label,
  showOnDisabled: () => false,
  validators: []
}

let hasPhoneSystemReporting = {
  fieldKey: "phoneSystemReporting",
  type: "switch",
  label: strings.form.service.hasPhoneSystemReporting.label,
  disabled: (getValues, getExtraValues) => {
    let credentials = getExtraValues().credentials();
    return !credentials.roles.includes('ROLE_NYUKOM');
  },
  showOnDisabled: () => false,
  validators: []
}

let technicalDataSearch = {
  fieldKey: "technicalDatas",
  type: "configurableField",
  label: "",
  validators: [],

  subField: (value, getValues, getExtraData) => {
    let extraData = getExtraData();
    if(extraData.technicalDatas && extraData.technicalDatas.total > 0) {
      let fields = extraData.technicalDatas.items.map((item, i) => {
        return {
          fieldKey: `${item.name}_${item.id}`,
          label: `DT ${item.name}`,
          type: "text",
          showOnDisabled: () => false,
          validators: [],
        }
      });

      return {
        subForm: {
          formKey: "technicalDatas",
          fields: fields
        },
      }
    }
    return {
      subForm: {
        formKey: "technicalDatas",
        fields: []
      },
    }
  },
  subFieldConf: {
    label: (value, getValues) => "",
    type: () => 'subform',
    disabled: () => false,
    validators: () => [],
  }
}

export const phoneForm = {
  formKey: "serviceSearch",
  fields: [
    serialNumber,
    orderNumber,
    quoteNumber,
    productName,
    partner,
    client,
    place,
    Object.assign({}, productSubFamily, {
      loader: Object.assign({}, productSubFamily.loader, {
        loaderRequire: () => true,
        loaderArguments: () => [{ phone_package: 1 }]
      })
    }),
    technicalDataSearch,
    emptyApiKey,
    consumptionDate
  ],
  extraValues: {
    credentials: () => store.getState().persisted.credentials,
    technicalDatas: {
      type: "load",
      loader: {
        loader: getSearchableTechnicalData,
        loaderRequire: (values) => values.productSubFamily && values.productSubFamily.id,
        loaderArguments: (values, extraValues) => {
          return [{ product_sub_family_id: values.productSubFamily.id }, true, false, !extraValues().credentials().roles.includes("ROLE_NYUKOM")]
        },
        reload: (values, prevValues) => {
          return values.productSubFamily && values.productSubFamily.id && (!prevValues.productSubFamily || values.productSubFamily.id !== prevValues.productSubFamily.id);
        }
      }
    }
  }
}

export const form = {
  formKey: "serviceSearch",
  fields: [
    serialNumber,
    orderNumber,
    quoteNumber,
    productName,
    price,
    // priceType,
    state,
    // status,
    partner,
    client,
    place,
    productFamily,
    productSubFamily,
    technicalDataSearch,
    terminationTicket,
    Object.assign({}, timeframe, {
      fieldKey: "deliveryDateTimeframe",
      label: `${strings.form.common.timeframe.label} ${strings.form.service.deliveryDateTimeframe.label}`
    }),
    deliveryDateMin,
    deliveryDateMax,
    Object.assign({}, timeframe, {
      fieldKey: "updateDateTimeframe",
      label: `${strings.form.common.timeframe.label} ${strings.form.service.updateDateTimeframe.label}`
    }),
    updateDateMin,
    updateDateMax,
    contractEndAtExpectedMin,
    contractEndAtExpectedMax,
    contractTacitAgreement,
    emptyApiKey,
    hasPhoneSystemReporting
  ],
  extraValues: {
    credentials: () => store.getState().persisted.credentials,
    technicalDatas: {
      type: "load",
      loader: {
        loader: getSearchableTechnicalData,
        loaderRequire: (values) => values.productSubFamily && values.productSubFamily.id,
        loaderArguments: (values, extraValues) => {
          return [{ product_sub_family_id: values.productSubFamily.id }, true, false, !extraValues().credentials().roles.includes("ROLE_NYUKOM")]
        },
        reload: (values, prevValues) => {
          return values.productSubFamily && values.productSubFamily.id && (!prevValues.productSubFamily || values.productSubFamily.id !== prevValues.productSubFamily.id);
        }
      }
    }
  }
}
